import { OnInit } from '@angular/core';
import angular from 'angular';
import { from } from 'rxjs';
const componentOptions = {
    bindings: {
        model: '=',
        containerForm: '=',
        show: '<',
        groupSelected: '<' 
    },
    controllerAs : 'giftCardsShippingInfoCtrl',
    templateUrl: ['GiftCardsAppConstants', (GiftCardsAppConstants: GiftCardsAppConstant): string => `${GiftCardsAppConstants.templatesRoute}ib-gift-cards-shipping-info-view.html`]
};
const componentInfo = {
    module: 'ib-gift-cards-configuration-form-module',
    selector: 'ibGiftCardsShippingInfo',
    inject:['$scope', 'localStorageService', 'GiftCardsAppConstants', '$timeout'],
    required: []
};
export class ibGiftCardsShippingInfo implements ng.IController {
    public EMAIL_PATTERN : string;
    public datePickerRoute: string;
    public model: Types.ShippingInfo;
    public hours: string[] = [];
    public minutes: string[] = [];
    public date: string;
    public selectedMinute: string;
    public selectedHour: string;
    public dateOptions: any; //tipar
    constructor (private $scope: angular.IScope, private localStorageService: angular.local.storage.ILocalStorageService, GiftCardsAppConstants: GiftCardsAppConstant, private $timeout: ng.ITimeoutService) {
        this.EMAIL_PATTERN = GiftCardsAppConstants.PATTERNS.EMAIL_PATTERN;
        this.datePickerRoute = `${GiftCardsAppConstants.templatesRoute}ib-datepicker.html`;

    }
    $onInit  (): void {
        this.initializeHours();
        this.initDateOptions();
    }

    initDateOptions = () => {
        this.dateOptions = {
            changeYear: false,
            changeMonth: false,
            minDate: 0, // Today
            maxDate: 360, // Today + x
            numberOfMonths: 2,
            firstDay: 1, // L M X J V S D
            hideIfNoPrevNext: false,
            stepMonths: 1 //Set how many months to move when clicking the previous/next links.
        };
    };
    removeEmails = (type:string) =>{
        this.$timeout(() => {
            if(type === 'checkEmail') {
                if(this.model.shippingOptionEmail === false) {
                    this.model.emailEmailReceiver = undefined;
                    this.model.emailEmailSender = undefined;
                    this.selectedHour = '04:00';
                    this.generateFormatedDate();
                }
            }else if(type === 'check-sender') {
                if(this.model.shippingOptionSender === false) {
                    this.model.senderEmailSender = undefined;
                    this.generateFormatedDate();
                }
            }
        }, 500);
    };

    onBlur = () : void =>{
        this.model.senderEmailSender = this.model.emailEmailSender;
    };

    senderEmailEquals = (from): void => {
        //this.model.shippingOptionEmail && this.model.shippingOptionSender && from == 'senderEmail' ? this.model.senderEmailSender = this. model.emailEmailSender : this. model.emailEmailSender = this.model.senderEmailSender;

        if(this.model.shippingOptionEmail && this.model.shippingOptionSender && from == 'senderEmail') {
            this.model.senderEmailSender = this.model.emailEmailSender;
        }else if(this.model.shippingOptionEmail && this.model.shippingOptionSender && from == '') {
            this.model.emailEmailSender = this. model.senderEmailSender;
        }
    };

    getHourFrom (dateSelected): number {
        const today= new Date();
        let isSameDay, isSameMonth;

        if(dateSelected) {
            isSameMonth = dateSelected.getMonth() +1 == today.getMonth() + 1;
            isSameDay = dateSelected.getDate() == today.getDate();
        }
        
        return isSameMonth && isSameDay ? today.getHours() + 2 : 4;
    }

    generateFormatedDate = (fromChangeDate= false):void => {
        if(this.date) {
            let hours = this.hours[0];
            const dateObj = new Date(this.date);
            const año = dateObj.getFullYear();
            const mes = String(dateObj.getMonth() + 1).padStart(2, '0');
            const día = String(dateObj.getDate()).padStart(2, '0');
            if(fromChangeDate) this.initializeHours(dateObj, true);
            hours = this.selectedHour ? this.selectedHour : '04:00';
            this.model.delivery.dateTime = `${año}-${mes}-${día} ${hours}`;
        }
    };

    initializeHours (date=new Date(), fromGenerateFormatedDate?): void {
        let hourFrom = 4;
        this.hours = [];
        
        if(this.model){
            hourFrom = this.getHourFrom(date);
        }
        
        for (let hour = hourFrom; hour < 21; hour++) {
            this.hours.push(hour < 10 ? '0' + hour + ':00' : '' + hour + ':00');
        }
        if(fromGenerateFormatedDate) this.selectedHour = this.hours[0];
    }    
}
try {
    const mod = angular.module(componentInfo.module);
    ibGiftCardsShippingInfo.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsShippingInfo })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibGiftCardsShippingInfo.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsShippingInfo })
    );
}
